<template>
  <div>
    <reportType />

    <router-view />
  </div>
</template>

<script>
import reportType from "@/components/reportType/index.vue";
export default {
  components: {
    reportType,
  },
};
</script>

<style>
</style>